//@ts-ignore
import Axios from "axios";
import { accessToken } from "./sessionKey";
import { toast } from "react-toastify";


const API_ROOT = 'https://notificationservice.careinfosolutions.com/api'


//create axios instance
export const instance = Axios.create({
  baseURL: `${API_ROOT}`,
  headers: {
    "Content-Type": "application/json",
  },
});



instance.interceptors.request.use(
  function (config: any) {
    config.headers = {
      'x-requested-with': '',
      authorization: `JWT ${accessToken()}`,
    };
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const { response } = error;
    if (response) {
      if (response.status === 404) {
        toast.error('Error');
      } else if (response.status === 401) {
        window.location.replace("/auth-login")
      } else {
        toast.error(response.data.msg);
      }
    }

    return Promise.reject(error);
  },
);

// create form data to upload files
export const postApiFormData = async (url: string, formData: any) => {
  let response;
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
      data: formData,
      transformResponse: [
        function (responseData: any) {
          //Do what ever you want transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e: any) {
    console.log(e.response);
    return e.response;
  }
  return response;
};


//get data from api
export const getApiData = async (url: string, param = null) => {
  let response;
  try {
    response = await instance({
      method: "GET",
      url: `${url}`,
      params: param,
      transformResponse: [
        function (responseData: any) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e: any) {
    return e.response;
  }
  return response;
};



//post data to api
export const postApiData = async (data: any) => {
  const { url, formData, setError } = data;
  let response;
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData: any) {
          //Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e: any) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError(key, { type: 'custom', message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};

//update data
export const putApiData = async (data: any) => {
  const { url, formData, formikProps } = data;

  // eslint-disable-next-line no-console
  let response;
  try {
    response = await instance({
      method: "PUT",
      url: `${url}`,
      data: formData,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData: any) {
          //Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e: any) {
    formikProps.setErrors(e.response.data);
    return e.response;
  }
  return response;
};

//delete data
export const deleteApiData = async (data: any) => {
  const { url } = data;
  let response;
  response = await instance({
    method: "DELETE",
    url: url,
    // params: param,
    headers: {
      Authorization: `JWT ${accessToken()}`,
    },
  });
  return response;
};


//update data
export const patchApiData = async (data: any) => {
  const { url, formData } = data;
  let response;
  try {
    response = await instance({
      method: "PATCH",
      url: `${url}`,
      data: formData,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData: any) {
          //Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e: any) {
    return e.response;
  }
  return response;
};
export { API_ROOT };
